import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import {BehaviorSubject, ReplaySubject} from 'rxjs';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-management-attributes-footer',
    styleUrls: ['./management-attributes-footer.component.scss'],
    templateUrl: './management-attributes-footer.component.html',
    standalone: false
})
export class ManagementAttributesFooterComponent implements OnInit {

    publishPinsToggle$ = new ReplaySubject<boolean>();
    hasPins$ = new ReplaySubject<boolean>();
    isPinOverrideGroupActive$ = new ReplaySubject<boolean>();

    // Declarations and instantiations
    @Input() disableCancel: boolean;
    @Input() disableUpdate: boolean;
    @Input() isRestoreVisible: boolean;
    @Input() areEditButtonsVisible: boolean;
    @Input()
    set publishPinsToggle(value: boolean) {
        this.publishPinsToggle$.next(value);
    }
    @Input()
    set hasPins(value: boolean) {
        this.hasPins$.next(value);
    }
    @Input()
    set isPinOverrideGroupActive(value: boolean) {
        this.isPinOverrideGroupActive$.next(value);
    }
    @Output() cancel = new EventEmitter<void>();
    @Output() submit = new EventEmitter<void>();
    @Output() restore = new EventEmitter<void>();
    @Output() publish = new EventEmitter<void>();
    @Output() forceOverride = new EventEmitter<void>();
    constructor() { }

    ngOnInit(): void {}

    handleCancel(): void {
        this.cancel.next();
    }

    handleSubmit(): void {
        this.submit.next();
    }

    handleRestore(): void {
        this.restore.next();
    }

    handlePublish(): void {
        this.publish.next();
    }

    handleForceOverride(): void {
        this.forceOverride.next();
    }
}
